import { VisualChartType } from './chart-type';
import { BarlikeChartTypes } from './types/bar-like';
import { ColumnlikeChartTypes } from './types/column-like';
import { OtherChartTypes } from './types/other';
import { PielikeChartTypes } from './types/pie-like';
import { TablelikeChartTypes } from './types/table-like';

export const PbiChartTypes = {
  ...BarlikeChartTypes,
  ...ColumnlikeChartTypes,
  ...OtherChartTypes,
  ...PielikeChartTypes,
  ...TablelikeChartTypes,
};

export const PbiChartTypesList =
  Object
    .keys(PbiChartTypes)
    .reduce((l, k) => (l.push((<Record<string, VisualChartType>>PbiChartTypes)[k]), l), <VisualChartType[]>[]);

export const SortedChartTypeList: ReadonlyArray<VisualChartType> = [
  PbiChartTypes.pivotTable,
  PbiChartTypes.table,
  PbiChartTypes.barChart,
  PbiChartTypes.columnChart,
  PbiChartTypes.clusteredBarChart,
  PbiChartTypes.clusteredColumnChart,
  PbiChartTypes.stackedBarChart,
  PbiChartTypes.stackedColumnChart,
  PbiChartTypes.hundredPercentStackedBarChart,
  PbiChartTypes.hundredPercentStackedColumnChart,
  PbiChartTypes.pieChart,
  PbiChartTypes.donutChart,
  PbiChartTypes.lineChart,
  // IN-7260
  // PbiChartTypes.areaChart,
  PbiChartTypes.card,
  PbiChartTypes.treemap,
  PbiChartTypes.waterfallChart
];

const PbiChartTypeByAlias =
  PbiChartTypesList.filter(t => !!t.alias)
    .reduce((m, t) => m.set(t.alias, t), new Map<string, VisualChartType>());

const PbiChartTypeByName =
  PbiChartTypesList
    .reduce((m, t) => m.set(t.name, t), new Map<string, VisualChartType>());

export function getInsightsPbiChartType(alias: string): VisualChartType {
  if (alias == 'tableEx')
    alias = 'table';

  return PbiChartTypeByAlias.get(alias) ?? PbiChartTypeByName.get(alias) ?? PbiChartTypes.unknown;
}

export function getPbiChartTypeName(typeName: string): string {
  if (typeName == 'tableEx')
    typeName = 'table';

  return getInsightsPbiChartType(typeName).name;
}

export function pbiChartEquals(typeOrString: VisualChartType | string, compareTo: VisualChartType) {
  if (typeof typeOrString !== 'string') {
    if (typeOrString === compareTo)
      return true;

    typeOrString = typeOrString.name;
  }

  return typeOrString == compareTo.name || typeOrString == compareTo.alias;

}
